// A wrapper wround Object.keys to return an interator with typed key
const keys = Object.keys as <T>(o: T) => Extract<keyof T, string>[];

export default keys;
